<template>
  <section class="Sponsors">
    <div class="Container" id="Sponsors">
      <section class="Section">
        <h3 class="Subtitle">General sponsors</h3>

        <div class="row justify-content-center">
          <div>
            <a class="Sponsor Sponsor-Krisp -main" href="https://krisp.ai/" target="_blank">
              <div class="Image"></div>
            </a>
          </div>
          <!-- <div>
            <a class="Sponsor Sponsor-Simply -main" href="https://www.simplytechnologies.net/" target="_blank">
              <div class="Image"></div>
            </a>
          </div> -->
        </div>
      </section>
      <!-- <section class="Section">
        <h3 class="Subtitle">Gold sponsors</h3>

        <div class="row justify-content-center">
        <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <a class="Sponsor Sponsor-NolanAI -gold" href="https://www.nolanai.app/" target="_blank">
              <div class="Image"></div>
            </a>
        </div>

          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <a class="Sponsor Sponsor-MentorcliQ -gold" href="https://www.mentorcliq.com/" target="_blank">
              <div class="Image"></div>
            </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <a class="Sponsor Sponsor-PicsArt -gold" href="https://picsart.com/" target="_blank">
              <div class="Image"></div>
            </a>
          </div>
            <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <a class="Sponsor Sponsor-Hexact -gold" href="https://hexact.io/" target="_blank">
              <div class="Image"></div>
            </a>
          </div>
            <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
            <a class="Sponsor Sponsor-WebbFontaine -gold" href="https://webbfontaine.com/" target="_blank">
              <div class="Image"></div>
            </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-Krisp -gold" href="https://krisp.ai/" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-Flux -gold" href="https://fluxtech.me/" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-10Web -gold" href="https://10web.io/" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-Sololearn -gold" href="https://www.sololearn.com/home" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-Adobe -gold" href="https://www.adobe.com/" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-Digitain -gold" href="https://www.digitain.com/" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-SPro -gold" href="https://s-pro.io/" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-EPAM -gold" href="https://www.epam.com/" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-CodeSignal -gold" href="https://codesignal.com/" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-VMware -gold" href="https://www.vmware.com/" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-Disqo -gold" href="https://disqo.com/" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
          <div class="SponsorCol col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
          <a class="Sponsor Sponsor-SoftConstruct -gold" href="https://www.softconstruct.com/" target="_blank">
            <div class="Image"></div>
          </a>
          </div>
        </div>
      </section> -->
      <!-- <section class="Section">
        <h3 class="Subtitle">Silver sponsors</h3>

        <div class="row justify-content-center">
          <div class="col-6 col-sm-4 col-md-3 col-lg-3 col-xl-2">
            <a class="Sponsor Sponsor-InConceptLab -silver" href="https://www.inconceptlabs.com/" target="_blank">
              <div class="Image"></div>
            </a>
          </div>
        </div>
      </section> -->
      <section class="Section">
        <h3 class="Subtitle">Silver sponsor</h3>
        <div class="row justify-content-center">
          <div class="col-6 col-sm-8 col-md-3 col-lg-3 col-xl-2">
            <a class="Sponsor Sponsor-Ameriabank -starter" href="http://www.ameriabank.am/" target="_blank">
              <div class="Image"></div>
            </a>
          </div>
          <div class="col-6 col-sm-8 col-md-3 col-lg-3 col-xl-2">
            <a class="Sponsor Sponsor-Synergy -starter" href="https://www.synisys.com/" target="_blank">
              <div class="Image"></div>
            </a>
          </div>
        </div>
      </section>
      <section class="Section">
        <h3 class="Subtitle">Partners and friends</h3>
        <div class="row justify-content-center">
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2">
            <a class="Sponsor Sponsor-Mootq -starter" href="https://mootq.am" target="_blank">
              <div class="Image"></div>
            </a>
          </div>
          <div class="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2">
            <a class="Sponsor Sponsor-SBC -starter" href="http://www.sbc.am/" target="_blank">
              <div class="Image"></div>
            </a>
          </div>
        </div>
      </section>
      <!-- <h2 class="Title">How to<br><span class="Accent">sponsor?</span></h2> -->
      <!-- <p class="IntroText">
          The application deadline: <strong>September 30, 2025</strong>
      <div class="CallToActionContainer">
        <a href="https://forms.gle/Lnx5x9b5J2C2qLbTA" class="Button -call-to-action" target="_blank">
          Become a sponsor!
        </a>
      </div>
      </p> -->
    </div>

    <div class="SponsorsBgTop"></div>
    <div class="SponsorsBgBottom"></div>
  </section>
</template>

<script>
export default {

};
</script>

<style scoped lang="scss">
.Sponsors {
  padding: 15vw 0;
  background-color: #f5f5f5;
  // background-image: url('./SponsorsBg.png');
  background-repeat: no-repeat;
  min-height: 1000px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.IntroText {
 font-size: 2em;
  font-weight: normal;
  line-height: 1.2em;
  margin-bottom: 1em;
}

.Container {
  position: relative;
  z-index: 3;
}

.Subtutle {
  color: #FF00AA;
  font-size: 32px;
}

.Section {
  margin-bottom: 30px;
}

.Subtitle {
  color: #acacac;
  color: #FF00AA;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: bold;
  font-size: 16px;
}

.HR {
  width: 100%;
  height: 1px;
}

.SponsorCol {
  margin-bottom: 25px;
}

.Title {
  font-size: 4em;
  font-weight: normal;
  line-height: 1.2em;
  margin-bottom: 1em;

  .Accent {
    font-size: 1.2em;
    color: #FF00AA;
    font-weight: 900;
  }
}

.Sponsor {

  padding-top: 20px;
  display: block;
  transition: all .3s ease;
  text-decoration: none;

  .Image {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: 50%;

    background-repeat: no-repeat;
    margin: 0 auto;
    margin-bottom: 10px;
  }

  .Name {
    text-align: center;
    color: rgb(170, 170, 170);
    text-decoration: none;
  }

  &.-main {

    .Image {
      height: 70px;
      width: 350px;
    }

    .Name {
      font-size: 1.2em;
    }
  }

  &.-gold {
    .Image {
      width: 250px;
      height: 60px;
    }

    .Name {
      font-size: 1.14em;
    }
  }

  &.-silver {
    .Image {
      width: 160px;
      height: 50px;
    }

    .Name {
      font-size: .9em;
    }
  }

  &.-starter {
    .Image {
      width: 160px;
      height: 50px;
    }

    .Name {
      font-size: .9em;
    }
  }

  &.Sponsor-Krisp .Image {
    background-image: url('/sponsors/krisp.svg')
  }

  &.Sponsor-Mootq .Image {
    background-image: url('/sponsors/mootq.svg');
  }
  &.Sponsor-SBC .Image {
    background-image: url('/sponsors/sbc.png');
  }

  &.Sponsor-Ameriabank .Image {
    background-image: url('/sponsors/ameriabank.svg')
  }
  &.Sponsor-Synergy .Image {
    background-image: url('/sponsors/synergy.svg')
  }
}

.CallToActionContainer {
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
}

.SponsorsBgTop,
.SponsorsBgBottom {
  position: absolute;
  left: 0;
  right: 0;
  background-repeat: no-repeat;
  background-size: 100%;
}

.SponsorsBgTop {
  top: 0;
  padding-bottom: 15%;
  background-image: url('./SponsorsBgTop.svg');
  background-size: cover;
  background-position: right 0 bottom -17vw;
}

.SponsorsBgBottom {
  bottom: 0;
  padding-bottom: 15%;
  background-image: url('./SponsorsBgBottom.svg');
  background-size: cover;
  background-position: right 0 top -17vw;
}

@media (min-width: 1200px) {
  .Context {
    width: 90%;
  }
}

@media (max-width: 600px) {
  .Sponsors {
    padding: 50px 0 50px;
  }

  .Title {
    font-size: 3em;
  }

  .IntroText {
    font-size: 1.5em;
  }

  .Sponsor.-main .Image {
    height: 90px;
    width: 250px;
  }

  .Sponsor-aua .Image,
  .Sponsor-itjobs .Image {
    width: 80px !important;
    height: 80px !important;
  }

  .Sponsor.-silver .Image {
    width: 140px;
    height: 105px;
  }
}
</style>
